import ReliableApi from "@/api/reliable";

export default {
    data() {
        return {}
    },

    methods: {

        getHistoryData(deptids, searchStartDate, searchEndDate) {
            if (deptids.length != 0) {
                let params = {
                    deptids: deptids,
                    searchstartdate: searchStartDate,
                    searchenddate: searchEndDate,
                }
                ReliableApi.queryHisReliableValue(params).then(res => {
                    this.reliableValueAvg = res.hisReliableAvgValue;    //历史安全指数

                    let distributionData = [res.incidentHisAvgValue, res.workorderHisAvgValue, res.authorizedHisAvgValue, res.changeHisAvgValue, res.problemHisAvgValue, res.registerHisAvgValue];
                    this.renderDistributionChart(distributionData);     //历史安全指数分布

                    this.renderReliableValueChart(res.avgHisReliableValue);    //历史部门安全指数
                });
            } else {
                this.reliableValueAvg = 0;
                this.renderDistributionChart([]);
                this.renderReliableValueChart([]);
            }
        },

    },

}
